import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import DashboardTwoToneSvg from "@ant-design/icons-svg/es/asn/DashboardTwoTone";
import AntdIcon from "../components/AntdIcon";
var DashboardTwoTone = function DashboardTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DashboardTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  DashboardTwoTone.displayName = 'DashboardTwoTone';
}
export default /*#__PURE__*/React.forwardRef(DashboardTwoTone);